import { call, put } from 'redux-saga/effects'
import firebase from '../config/firebase'
import AppCustomizationActions from '../reducers/appCustomizationReducer'

export function* getCustomization({ payload: { screen, resource, orderBy } }) {
  try {
    const data = {}
    const field = orderBy && orderBy[0]
    const sortBy = orderBy ? orderBy[1] : 'asc'

    let collection = firebase
      .firestore()
      .collection('app_customization')
      .doc(screen)
      .collection(resource)

    if (field) {
      collection = collection.orderBy(field, sortBy)
    }

    const snapshot = yield call([collection, collection.get])

    snapshot.forEach(doc => {
      const snapshotData = doc.data()

      data[doc.id] = { ...snapshotData, id: doc.id }
    })

    yield put(AppCustomizationActions.setCustomization({ screen, resource, data }))
  } catch (e) {
    yield put(AppCustomizationActions.setCustomization({ screen, resource, data: {} }))
  }
}


// WEBPACK FOOTER //
// ./src/sagas/appCustomizationSaga.js